function initialize() {
    $('.faq .item').on('click', function () {
        var isSelected = $(this).hasClass('open');

        $('.faq .item').removeClass('open');

        if (!isSelected) {
            $(this).addClass('open');
            $(this).find('a').removeAttr('tabindex');
        } else {
            $(this).find('a').attr('tabindex', -1);
        }
    });
}

initialize();
